import React from 'react';
import { Modal, Box, Button } from '@mui/material';

import { ControlledTextField } from '@/src/ui';
import { ControlledDynamicTextEditor, ControlledDynamicEquationEditor } from '@/src/lib';

export interface TextEntryModalPartialProps {
    initialData: string;
    fieldName: string;
    friendlyName: string;
    textMode: 'rich' | 'plain' | 'equation';
    error?: string;
}
type TextEntryModalProps = TextEntryModalPartialProps & {
    currentValue?: string;
    control: any;
    showKeypad?: boolean;
    allowedKeys?: string[];
    handleClose: () => void;
};

const TextEntryModal: React.FC<TextEntryModalProps> = (props) => {
    const {
        initialData,
        currentValue,
        control,
        fieldName,
        friendlyName,
        textMode,
        showKeypad = false,
        allowedKeys = [],
        error,
        handleClose,
    } = props;

    return (
        <Modal open onClose={() => handleClose()}>
            <Box sx={{ p: 4, bgcolor: 'background.paper', margin: 'auto', mt: 8, width: 1000 }}>
                <h2>Edit {friendlyName}</h2>
                {textMode === 'rich' ? (
                    <ControlledDynamicTextEditor
                        name={fieldName}
                        initialValue={initialData}
                        control={control}
                        error={error}
                    />
                ) : textMode === 'equation' ? (
                    <>
                        <ControlledDynamicEquationEditor
                            name={fieldName}
                            initialValue={initialData}
                            contentKey="textentry-modal-equation"
                            showKeypad={showKeypad}
                            allowedKeys={allowedKeys}
                            control={control}
                            error={error}
                        />

                        {/* LIMIT 2000 because quotes get escaped & db limit is 3000 */}
                        {currentValue && <div>{currentValue.length}/2000 compressed length</div>}
                    </>
                ) : (
                    <ControlledTextField
                        name={fieldName}
                        control={control}
                        label={`${friendlyName}`}
                        error={error}
                    />
                )}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
                    <Button variant="outlined" onClick={() => handleClose()}>
                        Close
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default TextEntryModal;
